import styled, { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { Flex } from 'Components/UI'

export const Container = styled(Flex).attrs({
  mt: 30,
})`
  height: 4px;
  box-sizing: content-box;
  border-bottom: 1px solid ${themeGet('colors.calculator.border')};
`

const dragPink = ({ pink }) =>
  pink &&
  css`
    background-color: ${themeGet('colors.pinkAmaranth')};
  `

const shouldForwardProp = prop => {
  return !['pink'].includes(String(prop))
}

export const Drag = styled(Flex).withConfig({
  shouldForwardProp,
})`
  height: 4px;
  border-radius: 2px;
  background-color: ${themeGet('colors.calculator.action')};

  ${dragPink}
`
